import type { ActivityType } from '../../../typings'
import type { CreateActivityType } from './typings'

export const createActivityTypeActionCreator = (
  payload?: ActivityType,
): CreateActivityType => ({
  type: 'activityTypes/create',
  payload,
})
